export default "__VITE_ASSET__Y74fpW3f__"